var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.id}},[(_vm.navs.length > 0)?_c('VTabs',{class:{fixed: _vm.fixed},attrs:{"value":_vm.curTab},on:{"change":_vm.handleTabChange}},_vm._l((_vm.navs),function(ref,index){
var path = ref.path;
var title = ref.title;
return (path)?_c('VTab',{key:index,attrs:{"title":title,"value":path}}):_vm._e()}),1):_vm._e(),_c('Transition',{attrs:{"name":_vm.transitionName}},[_c('KeepAlive',[_c('RouterView')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }